module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/jX0Elt/tc-custom/9780805099720.jpg?1737749006220",
      "alt": "This image is the cover for the book Tales of Bunjitsu Bunny"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Tales of Bunjitsu Bunny\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("This children’s series debut introduces a martial arts-loving bunny who “delivers a series of Zen lessons touched with gentle humor” ("), _c('i', [_vm._v("Kirkus Reviews")]), _vm._v(").")]), _c('br'), _c('br'), _vm._v("Meet Isabel, aka Bunjitsu Bunny! She is the BEST bunjitsu artist in her school, and she can throw farther, kick higher, and hit harder than anyone else. But she never hurts another creature . . . unless she has to. This series of brief stories about Isabel’s adventures combine fun, child-friendly scenarios and Eastern wisdom perfect for the youngest readers.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      John Himmelman\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Henry Holt and Company\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0